export default __webpack_public_path__ + "static/media/thumb_14.8eeaf32f.webp";